module.exports = __webpack_public_path__ + "static/media/icon_gth.a92b32d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/icon_gth.png
// module id = 1974
// module chunks = 0